"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabPanel = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react/no-children-prop */


var TabPanel = function TabPanel(_ref) {
  var path = _ref.path,
      children = _ref.children;
  return _react.default.createElement(_reactRouterDom.Route, {
    path: path,
    render: function render() {
      return {
        children: children
      };
    }
  });
};

exports.TabPanel = TabPanel;
var _default = TabPanel;
exports.default = _default;